import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { InputAdornment } from '@mui/material';
import styles from './DimensionsModal.module.css';
import SelectInput from '../../ReusableComponents/SelectInputV2/SelectInput';

function SizeSelectInput({ name, currentValue = null, onChange }) {
  const sizeOptions = useMemo(() => {
    const options = [];
    const existingItem = {
      value: currentValue,
      text: currentValue,
    };

    for (let i = 0.25; i <= 100; i += 0.25) {
      options.push({
        value: i,
        text: i,
      });

      if (
        options.findIndex((x) => x.value === currentValue) === -1 &&
        currentValue < i
      ) {
        options.splice(options.length - 1, 0, existingItem);
      }
    }

    if (currentValue > 100) {
      options.push(existingItem);
    }

    return options;
  }, []);

  return (
    <SelectInput
      name={`${name}_field`}
      label={name}
      fullWidth
      native
      value={currentValue || ''}
      onChange={({ target: { value } }) => onChange(parseFloat(value))}
      autoComplete="no"
      options={sizeOptions}
      endAdornment={
        <InputAdornment className={styles.sizeEndAdornment} position="end">
          inches
        </InputAdornment>
      }
    />
  );
}

SizeSelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  currentValue: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default SizeSelectInput;
